import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentOwnerMappingDto, IdentityUserDto, AssetLocationDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { AcquisitionGenericFacade } from './../../../../../incident/src/lib/states/+acquisition-generic/acquisition-generic.facade';
import { GatewayService } from 'libs/gateway/src/lib/services/gateway.service';


@Component({
  selector: 'cradua-incidentownersmapping-container',
  templateUrl: './incidentownersmapping-container.component.html',
  styleUrls: ['./incidentownersmapping-container.component.scss']
})
export class IncidentownersmappingContainerComponent implements OnInit {

 
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentOwnersMappings$: Observable<IncidentOwnerMappingDto[]>;
  owners$: Observable<IdentityUserDto[]>;
  assetLocations$: Observable<AssetLocationDto[]>;
  loading: boolean;
  isLoadingIncidentOwnersMapping$: Observable<boolean>;
  isLoadingOwners$: Observable<boolean>;
  isLoadingAssetLocation$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,private gatewayService: GatewayService, private acquisitionGenericFacade: AcquisitionGenericFacade
  ) {}

  ngOnInit() {
    this.isLoadingIncidentOwnersMapping$ = this.gatwayFacade.isLoadingGateway("IncidentOwnerMapping");
    this.isLoadingOwners$ = this.gatwayFacade.isLoadingGateway("IdentityUser");
    this.isLoadingAssetLocation$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric("AssetLocation");

    this.incidentOwnersMappings$ = this.gatwayFacade.loadGateway("IncidentOwnerMapping");
    this.owners$ = this.gatwayFacade.loadGateway("IdentityUser");
    this.assetLocations$ =  this.gatewayService.getAllGeneric("AssetLocation", {},1000,0);
    
 
    
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

 onDeleteIncidentOwnersMapping(deletedValue: any) {
    this.gatwayFacade.remove("IncidentOwnerMapping", deletedValue);
  }

  
// this method control both the create and update

onSubmitIncidentOwnersMapping(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentOwnerMappings;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllIncidentOwnerMapping = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllIncidentOwnerMapping.push(pullData[i]);
    }
  }

// check if the addAllIncidentOwnerMapping array is not empty, then dispatch the data to the store
   if(addAllIncidentOwnerMapping.length > 0) {
    this.gatwayFacade.add('IncidentOwnerMapping', addAllIncidentOwnerMapping);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('IncidentOwnerMapping', allUpdates, ['id']);
  }

   }

}
